module.exports = __webpack_public_path__ + "trash-outline.png?cea0a53c02d08716d2bbcb35790cc7f9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vectors/trash-outline.png
// module id = 1079
// module chunks = 0